import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/partners')({
  staticData: { breadcrumb: 'Partners' },
  component: () => <Outlet />,
});
